<template>
    <div class="mh-middle">
        <div class="mh-middle-inner">
            <ContentTitle title="Schedule" />

            <div class="mh-time-top">
                <b-row no-gutters>
                    <b-col cols="auto">
                        <div class="mh-entries-nav-container">
                            <div class="mh-time-entries-nav">
                                <span @click="changeDate(-1)"><i class="mh-icon-left"></i></span>
                                <span>
                                    <b-dropdown size="lg" variant="link" class="schedule-calendar" ref="calendarDropdown" no-caret>
                                        <template slot="button-content">
                                            {{displayDate}}
                                        </template>

                                        <b-dropdown-form>
                                            <b-calendar v-model="date" :hide-header="true" :value-as-date="true" @selected="onCalendarChange"></b-calendar>
                                        </b-dropdown-form>
                                    </b-dropdown>
                                </span>
                                <span @click="changeDate(1)"><i class="mh-icon-right"></i></span>
                            </div>
                            <a @click="refreshScheduleBoard" title="Reload schedule board"><i class="mh-icon-refresh"></i></a>
                        </div>
                    </b-col>
                    <b-col md="" class="p-0">
                        <div class="mh-schedule-right">
                            <div class="mh-filters-top">
                                <a @click="setPeriod('Day', 'days', 1)" :class="period.title == 'Day' ? 'active' : ''">Day</a>
                                <a @click="setPeriod('Week', 'weeks', 1)" :class="`d-none d-lg-block${period.title == 'Week' ? ' active' : ''}`">Week</a>
                                <a @click="setPeriod('Fortnight', 'weeks', 2)" :class="`d-none d-lg-block${period.title == 'Fortnight' ? ' active' : ''}`">Fortnight</a>
                                <a @click="setPeriod('Month', 'months', 1)" :class="period.title == 'Month' ? 'active' : ''">Month</a>
                            </div>
                            <div v-if="period.title != 'Month'" class="mh-filters-options">
                                <a @click="setIsFiltered(false)" :class="!filters.clientsWithShiftsOnly ? 'active' : ''">All</a>
                                <a @click="setIsFiltered(true)" :class="filters.clientsWithShiftsOnly ? 'active' : ''" >Filtered</a>
                            </div>
                            <a @click="resetFilters" title="Reset filters"><i class="mh-icon-undo reset-filters"></i></a>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <div class="mh-middle-container">
                <div class="mh-schedule-row">
                    <div class="mh-profile-label">
                        <div class="mh-img-wrap">
                            <ProfileImage :imageUrl="profilePicture" />
                            <span class="mh-user-online"></span>
                        </div>
                        <span class="mh-title">{{profile.email}}</span>
                    </div>
                    <div class="ml-lg-3 mh-schedule-folders">
                        <a @click="filters.status.pending = !filters.status.pending" :class="`pending${(filters.status.pending ? ' active' : '')}`"><span>Pending</span><small>{{statusCounts.pending}}</small><i v-if="filters.status.pending" class="mh-icon-eye"></i></a>
                        <a @click="filters.status.unconfirmed = !filters.status.unconfirmed" :class="`unconfirmed${(filters.status.unconfirmed ? ' active' : '')}`"><span>Unconfirmed</span><small>{{statusCounts.unconfirmed}}</small><i v-if="filters.status.unconfirmed" class="mh-icon-eye"></i></a>
                        <a @click="filters.status.scheduled = !filters.status.scheduled" :class="`scheduled${(filters.status.scheduled ? ' active' : '')}`"><span>Scheduled</span><small>{{statusCounts.scheduled}}</small><i v-if="filters.status.scheduled" class="mh-icon-eye"></i></a>
                        <a @click="filters.status.completed = !filters.status.completed" :class="`completed${(filters.status.completed ? ' active' : '')}`"><span>Completed</span><small>{{statusCounts.completed}}</small><i v-if="filters.status.completed" class="mh-icon-eye"></i></a>
                        <a @click="filters.status.cancelled = !filters.status.cancelled" :class="`cancelled${(filters.status.cancelled ? ' active' : '')}`"><span>Cancelled</span><small>{{statusCounts.cancelled}}</small><i v-if="filters.status.cancelled" class="mh-icon-eye"></i></a>
                        <a @click="filters.status.unpublished = !filters.status.unpublished" :class="`unpublished${(filters.status.unpublished ? ' active' : '')}`"><span>Unpublished</span><small>{{statusCounts.unpublished}}</small><i v-if="filters.status.unpublished" class="mh-icon-eye"></i></a>
                        <a @click="filters.status.error = !filters.status.error" :class="`error${(filters.status.error ? ' active' : '')}`"><span>Error</span><small>{{statusCounts.error}}</small><i v-if="filters.status.error" class="mh-icon-eye"></i></a>
                    </div>
                </div>
                <div id='calendar'>
                    <ScheduleBoardMonthView v-if="period.title == 'Month' && hasCustomers" :date="date" :period="period" :filters="filters" @shifts="shiftsRefresh" />
                    <ScheduleBoard v-if="period.title != 'Month' && hasCustomers" :date="date" :period="period" :filters="filters" @shifts="shiftsRefresh" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ContentTitle from "./partials/ContentTitle"
    import ProfileImage from './partials/ProfileImage'
	import ScheduleBoard from "./partials/ScheduleBoard"
	import ScheduleBoardMonthView from "./partials/ScheduleBoardMonthView"
    import moment from "moment"

    export default {
		name: 'ScheduleContent',
        components: {
            ContentTitle,
            ProfileImage,
			ScheduleBoard,
			ScheduleBoardMonthView
        },
        data: function () {
            return {
                date: new Date(),
                period: {
					title: "Fortnight",
                    type: "weeks",
                    number: 2
				},
                filters: {
					status: {
						pending: true,
						unconfirmed: true,
						scheduled: true,
						completed: true,
						cancelled: true,
						unpublished: true,
						error: true
                    },
                    clientsWithShiftsOnly: false
                },
				statusCounts: {
					pending: 0,
					unconfirmed: 0,
					scheduled: 0,
					completed: 0,
					cancelled: 0,
					unpublished: 0,
					error: 0
				},
                refreshedShifts: null
            }
        },
		mounted: function () {
			this.date = this.dateFrom

			window.removeEventListener('resize', this.initPeriod)
			window.addEventListener('resize', this.initPeriod)

			this.initPeriod()
		},
        computed: {
            profile: function () {
                return this.$store.state.Profile.profile
            },
            profilePicture: function () {
				return this.profile.profilepic
			},
			hasCustomers: function () {
				return this.$store.state.Customers.customers.length > 0
			},
			dateFrom: function () {
				return this.$store.state.Shifts.date
			},
            displayDate: function () {
                var date = moment(this.date).format("MMM YYYY")

                if (this.period.title == "Month")
                    date = moment(this.date).format("MMMM YYYY")

				if (this.period.title == "Fortnight")
					date = `${moment(this.date).format("DD MMM")} - ${moment(this.date).add(-1, "days").add(2, "weeks").format("DD MMM")}`

				if (this.period.title == "Week")
					date = `${moment(this.date).format("DD MMM")} - ${moment(this.date).add(-1, "days").add(1, "weeks").format("DD MMM")}`

				if (this.period.title == "Day")
                    date = moment(this.date).format("DD MMM YYYY")

				return date
			}
        },
		methods: {
			initPeriod: function () {
				if (window.innerWidth < 768) {
					this.setPeriod("Month", "months", 1)
				}
				else {
					this.setPeriod("Fortnight", "weeks", 2)
				}
			},
			onCalendarChange: function () {
				this.$store.commit("Shifts/setDate", this.date)

				this.$refs.calendarDropdown.hide()
			},
			changeDate(i) {
				this.date = moment(this.date).add(this.period.number * i, this.period.type).toDate()

				this.$store.commit("Shifts/setDate", this.date)
			},
            refreshScheduleBoard: function () {
                var $this = this

                this.$store.dispatch("Customers/getCustomers").then(function () {
					$this.date = moment($this.date).add(1, "seconds").toDate()
                })
			},
            setPeriod: function (title, type, number) {
				this.$set(
					this,
					"period",
					{
						title: title,
						type: type,
						number: number
					}
				)
            },
            getDefaultFilters: function () {
                return {
					status: {
						pending: true,
						unconfirmed: true,
						scheduled: true,
						completed: true,
						cancelled: true,
						unpublished: true
					},
					clientsWithShiftsOnly: false
                }
			},
			setIsFiltered: function (isFiltered) {
				this.$set(this.filters, "clientsWithShiftsOnly", isFiltered)
            },
            resetFilters: function () {
				this.filters = this.getDefaultFilters()
				this.date = new Date()
			},
            shiftsRefresh: function (shifts) {
				this.refreshedShifts = shifts
                this.setStatusCounts(shifts)
			},
			setStatusCounts: function (shifts) {
                this.statusCounts = {
					pending: shifts.filter(x => x.statusColor == "pending").length,
					unconfirmed: shifts.filter(x => x.statusColor == "unconfirmed").length,
					scheduled: shifts.filter(x => x.statusColor == "scheduled").length,
					completed: shifts.filter(x => x.statusColor == "completed").length,
					cancelled: shifts.filter(x => x.statusColor == "cancelled").length,
					unpublished: shifts.filter(x => x.statusColor == "unpublished").length,
					error: shifts.filter(x => x.statusColor == "error").length
				}
			}
		}
    };
</script>

<style>
	.pending {
		background-color: #FFEDD1 !important;
		color: #F8A830 !important;
	}

		.pending.shift {
			border-top: 2px solid #F8A830 !important;
		}

		.pending small {
			background: #F8A830 !important;
		}

	.unconfirmed {
		background-color: #FFDAD2 !important;
		color: #E34D2C !important;
	}

		.unconfirmed.shift {
			border-top: 2px solid #E34D2C !important;
		}

		.unconfirmed small {
			background: #E34D2C !important;
		}

	.scheduled {
		background-color: #eaf0ff !important;
		color: #4a77e9 !important;
	}

		.scheduled.shift {
			border-top: 2px solid #4a77e9 !important;
		}

		.scheduled small {
			background: #4a77e9 !important;
		}

	.completed {
		background-color: #E2FDFF !important;
		color: #4ADFE9 !important;
	}

		.completed.shift {
			border-top: 2px solid #4ADFE9 !important;
		}

		.completed small {
			background: #4ADFE9 !important;
		}

	.cancelled {
		background-color: #FEE4FF !important;
		color: #E43CE8 !important;
	}

		.cancelled.shift {
			border-top: 2px solid #E43CE8 !important;
		}

		.cancelled small {
			background: #E43CE8 !important;
		}

	.unpublished {
		background-color: #DEE1FF !important;
		color: #232A72 !important;
	}

		.unpublished.shift {
			border-top: 2px solid #232A72 !important;
		}

		.unpublished small {
			background: #232A72 !important;
		}

	.error {
		background-color: #ffa693 !important;
		color: #df2800 !important;
	}

		.error.shift {
			border-top: 2px solid #df2800 !important;
		}

		.error small {
			background: #df2800 !important;
		}

	.multiple-shifts {
		background-color: #eceff5 !important;
		color: #828181 !important;
	}

		.multiple-shifts.shift {
			border-top: 2px solid #828181 !important;
		}
</style>
<style scoped>
	.mh-middle {
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
	}

    .mh-profile-label {
        width: unset;
        margin: 0;
        padding: 10px;
    }

        .mh-profile-label .mh-img-wrap img {
            width: unset;
        }
</style>